import {
  useState,
  useCallback,
  type PropsWithChildren,
  useEffect,
} from "react";

import { Snackbar } from "@/components/Snackbar/Snackbar";
import { SnackbarContext } from "@/contexts/SnackbarContext/SnackbarContext";
import { type SnackbarMessage } from "@/types/types";

export const SnackbarProvider = ({ children }: PropsWithChildren) => {
  const [snackbar, setSnackbar] = useState<SnackbarMessage | null>(null);

  const handleClose = useCallback(() => {
    setSnackbar(null);
  }, []);

  useEffect(() => {
    const handleNewMessage: WindowEventHandler<"snackbarmessageopen"> = (
      event,
    ) => {
      setSnackbar(event.detail);
    };

    window.addEventListener("snackbarmessageopen", handleNewMessage);

    return () => {
      window.removeEventListener("snackbarmessageopen", handleNewMessage);
    };
  }, []);

  return (
    <SnackbarContext.Provider value={setSnackbar}>
      {children}
      <Snackbar
        open={!!snackbar}
        message={snackbar?.content}
        onClose={handleClose}
      />
    </SnackbarContext.Provider>
  );
};
